import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';

const marketPlaceOrgId = 481;

const { VehicleTitleSpecs } = Vehicle;

const VehicleTitle = ({ quote, vehicle, deleteQuote, isMultiDealerGarage }) => {
    const isInApprovalStatus = quote.isQuoteInApproval();
    const isQuoteInPending = quote.isQuoteInPending();
    const isQuoteDelivered = quote.isQuoteDelivered();
    const pendingTransKey = isInApprovalStatus ? 'GARAGE.PENDING_APPROVAL' : 'GARAGE.PENDING_TRANSACTIONS';
    const completedTransKey = isQuoteDelivered && 'GARAGE.COMPLETED_TRANSACTION';
    const isAvailable = isQuoteInPending || vehicle.isAvailable();
    const props = {
        vehicle,
        url: isAvailable
            ? quote.getVDPUrl(false, isMultiDealerGarage && quote?.orgId === marketPlaceOrgId, quote?.orgUnitId)
            : '',
        className: 'vehicle-title-header sr-text is-bold',
        isAvailable,
    };

    const titleBody = [<VehicleTitleSpecs {...props} />];

    if (!isQuoteInPending && !isInApprovalStatus) {
        const deleteButton = (
            <button className="vehicle-delete" onClick={() => deleteQuote(quote, isMultiDealerGarage)}>
                <p className="vehicle-delete__label">{LocaleService.t('GARAGE.REMOVE_VEHICLE')}</p>
                <icon className="icon-trash-can" />
            </button>
        );
        titleBody.push(deleteButton);
    } else {
        titleBody.push(
            <p className="vehicle-transaction">
                {LocaleService.t(isQuoteDelivered ? completedTransKey : pendingTransKey)}
            </p>
        );
    }

    return <div className="vehicle-title__wrapper">{titleBody}</div>;
};

VehicleTitle.defaultProps = { isMultiDealerGarage: false };

VehicleTitle.propTypes = {
    deleteQuote: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
};

VehicleTitle.displayName = 'VehicleTitle';

export default VehicleTitle;
